import { BaseCrud, Static } from 'core-components/types'

const data = ['Table', 'AccordionFilter']

export const libraryTypeSource = new BaseCrud({
  fetcher: new Static(data.map((el) => ({ value: el, label: el }))),
  keyField: 'value',
})
